import { render, staticRenderFns } from "./MyPayForm.vue?vue&type=template&id=0b44b230"
import script from "./MyPayForm.vue?vue&type=script&lang=js"
export * from "./MyPayForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports